import { getUserOrders, getUserSettlements } from "./digitalWalletService";
import { getLedgerEntries } from "./investService";
import { transferFunds } from "./settingsService";

export const findUserActivities = async (account) => {
  try {
    const [rawOrders, rawInvestments, rawSettlments] = await Promise.all([
      getUserOrders(account?.userId),
      getLedgerEntries(account?.userId),
      getUserSettlements(account?.userId, account?._id),
    ]);

    const orders = rawOrders?.data?.data?.results;
    const investments = rawInvestments?.data?.data?.results;
    const settlements = rawSettlments?.data?.data;

    const accountInvestments = investments.filter(
      (investments) => investments?.accountId === account?._id
    );
    const accountOrders = orders?.filter(
      (order) => order?.accountId === account?._id
    );
    const activeInvestments = accountInvestments.filter(
      (investment) => Number(investment?.balance) > 0
    );

    const pendingOrders =
      accountOrders?.filter((order) => order.status === "pending") || [];
    const pendingSettlements =
      settlements?.filter((order) => order.status === "Pending") || [];
    return {
      pendingOrders,
      activeInvestments,
      pendingSettlements,
      hasPendingOrders: pendingOrders.length > 0,
      hasActiveInvestments: activeInvestments.length > 0,
      hasPendingSettlements: pendingSettlements.length > 0,
    };
  } catch (error) {
    console.error("❌ findUserActivities error:", error);
    return {
      pendingOrders: [],
      investments: [],
      settlements: [],
      hasPendingOrders: false,
      hasActiveInvestments: false,
      hasPendingSettlements: false,
    };
  }
};
export const transferMultipleAccountFunds = async (allTransfers) => {
  const results = [];

  for (const transfer of allTransfers) {
    try {
      const response = await transferFunds(transfer);
      results.push({ success: true, response });
    } catch (error) {
      results.push({ success: false, error, transfer });
    }
  }

  return results;
};
